import { useAsyncList } from '@react-stately/data';
import { captureException } from '@sentry/react';
import { useAppApiClient } from 'app/api/app-api/AppApiClientContext';
import { debounce } from "../core/utils/debounce";
import { useCallback } from 'react';
import { ComboBox, InlineText, Text } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RegistrationCompanyField = _ref => {
  let {
    formik,
    name
  } = _ref;
  const apiClient = useAppApiClient();

  // Create a debounced function that fetches company suggestions.
  const loadSuggestions = useCallback(debounce(async _ref2 => {
    let {
      filterText,
      signal
    } = _ref2;
    // Don't fetch suggestions if the filter text is too short.
    if (filterText.length < 2) {
      return {
        items: []
      };
    }
    try {
      const response = await apiClient.getGlobalCompanySuggestions({
        query: filterText,
        signal
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch company suggestions: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      return {
        items: data
      };
    } catch (error) {
      if (error.name !== 'AbortError') {
        captureException(error);
        console.error(error);
      }

      // In case of an error, return an empty list of items. The user still
      // can enter a custom value.
      return {
        items: []
      };
    }
  }, 300), [apiClient]);
  const companySuggestions = useAsyncList({
    load: loadSuggestions
  });
  return /*#__PURE__*/_jsx(ComboBox.Root, {
    allowsCustomValue: true,
    error: formik.touched[name] && formik.errors[name]?.name,
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Company ", /*#__PURE__*/_jsx(InlineText, {
        variant: "danger",
        children: "*"
      })]
    }),
    items: companySuggestions.items,
    inputValue: formik.values[name]?.name ?? '',
    onInputChange: value => {
      formik.setFieldValue(name, {
        name: value
      });
      companySuggestions.setFilterText(value);
    },
    onSelectionChange: item => {
      if (item) {
        formik.setFieldValue(name, companySuggestions.items.find(i => i.id === item));
      }
    },
    selectedKey: formik.values[name]?.id ?? '',
    ...formik.getFieldProps(name),
    "data-sentry-element": "unknown",
    "data-sentry-component": "RegistrationCompanyField",
    "data-sentry-source-file": "RegistrationCompanyField.tsx",
    children: item => /*#__PURE__*/_jsxs(ComboBox.Item, {
      textValue: item.name,
      children: [/*#__PURE__*/_jsx(Text, {
        as: "div",
        children: item.name
      }), /*#__PURE__*/_jsx(Text, {
        as: "div",
        size: "s",
        variant: "secondary",
        children: item.address
      })]
    }, item.id)
  });
};